import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-consent-banner.component.html',
  styles: [`
    @keyframes slideUp {
      from {
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    .slide-up-enter {
      animation: slideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    @keyframes slideDown {
      from {
        transform: translateY(0);
        opacity: 1;
      }
      to {
        transform: translateY(100%);
        opacity: 0;
      }
    }

    .slide-down-exit {
      animation: slideDown 0.3s cubic-bezier(0.4, 0, 1, 1);
    }
  `]
})
export class CookieConsentBannerComponent {
  private cookieService = inject(CookieConsentService);
  
  isVisible = signal(false);
  isExiting = signal(false);

  ngOnInit() {
    // แสดง banner หากยังไม่ได้ให้ consent
    if (!this.cookieService.hasConsent()) {
      // Delay เล็กน้อยเพื่อให้ animation ทำงาน
      setTimeout(() => {
        this.isVisible.set(true);
      }, 500);
    }
  }

  acceptAll() {
    this.hideBanner(() => {
      this.cookieService.acceptAll();
    });
  }

  rejectAll() {
    this.hideBanner(() => {
      this.cookieService.reject();
    });
  }

  private hideBanner(callback: () => void) {
    this.isExiting.set(true);
    setTimeout(() => {
      this.isVisible.set(false);
      callback();
    }, 300);
  }
}
